
import React from 'react';
import './style.css';

function Navbar(){
    return (
        <nav>
            <h1>Employee Directory</h1>
        </nav>
    )
};

export default Navbar;